import { useContext } from 'react';

import { QSetReviewModalContext } from './qset-review-modal-provider';

export function useQSetReviewModal() {
  const context = useContext(QSetReviewModalContext);

  if (!context) {
    throw new Error('useQSetReviewModal must be used within a QSetReviewModalContextProvider');
  }

  return context;
}
